import { getAllLots, CATEGORIES_LOTS } from '../../2-ratio/data/lotsData';
import type { Lot } from '../../2-ratio/data/lotsData';

// ── Types locaux pour le panneau classifying ──

export interface ClassifyingEnsemble {
  id: string;
  nom: string;
  categorieId: string; // réfère à CategorieLot.id
  sections: ClassifyingSousEnsemble[];
}

export interface ClassifyingSousEnsemble {
  id: string;
  nom: string;
}

// ── Ensembles mock dédiés, rattachés aux catégories de lots ──

export const CLASSIFYING_ENSEMBLES: ClassifyingEnsemble[] = [
  // ── Préparation et Démolition ──
  {
    id: 'ens-curage',
    nom: 'Curage Intérieur',
    categorieId: 'preparation',
    sections: [
      { id: 'se-curage-depose', nom: 'Dépose éléments' },
      { id: 'se-curage-evacuation', nom: 'Évacuation gravats' },
      { id: 'se-curage-tri', nom: 'Tri sélectif' },
    ],
  },
  {
    id: 'ens-demolition-struct',
    nom: 'Démolition Structurelle',
    categorieId: 'preparation',
    sections: [
      { id: 'se-demo-murs', nom: 'Abattage murs' },
      { id: 'se-demo-plancher', nom: 'Démolition planchers' },
      { id: 'se-demo-charpente', nom: 'Dépose charpente' },
    ],
  },

  // ── Structure et Fondations ──
  {
    id: 'ens-fondation-superficielle',
    nom: 'Kit Fondation Superficielle',
    categorieId: 'structure',
    sections: [
      { id: 'se-fond-terrassement', nom: 'Terrassement' },
      { id: 'se-fond-proprete', nom: 'Béton de propreté' },
      { id: 'se-fond-armatures', nom: 'Armatures' },
      { id: 'se-fond-beton', nom: 'Béton coulé' },
    ],
  },
  {
    id: 'ens-fondation-profonde',
    nom: 'Kit Fondation Profonde',
    categorieId: 'structure',
    sections: [
      { id: 'se-fondp-pieux', nom: 'Pieux forés' },
      { id: 'se-fondp-longrines', nom: 'Longrines BA' },
      { id: 'se-fondp-massifs', nom: 'Massifs de liaison' },
    ],
  },
  {
    id: 'ens-voile-ba',
    nom: 'Voile BA',
    categorieId: 'structure',
    sections: [
      { id: 'se-voile-coffrage', nom: 'Coffrage' },
      { id: 'se-voile-ferraillage', nom: 'Ferraillage' },
      { id: 'se-voile-coulage', nom: 'Coulage béton' },
      { id: 'se-voile-decoffrage', nom: 'Décoffrage' },
    ],
  },
  {
    id: 'ens-dalle-ba',
    nom: 'Dalle BA',
    categorieId: 'structure',
    sections: [
      { id: 'se-dalle-etai', nom: 'Étaiement' },
      { id: 'se-dalle-coffrage', nom: 'Coffrage plancher' },
      { id: 'se-dalle-armatures', nom: 'Armatures TS / HA' },
      { id: 'se-dalle-coulage', nom: 'Coulage dalle' },
    ],
  },

  // ── Enveloppe du Bâtiment ──
  {
    id: 'ens-facade-enduit',
    nom: 'Façade Enduit',
    categorieId: 'enveloppe',
    sections: [
      { id: 'se-facade-gobetis', nom: 'Gobetis' },
      { id: 'se-facade-corps', nom: 'Corps d\'enduit' },
      { id: 'se-facade-finition', nom: 'Finition grattée' },
    ],
  },
  {
    id: 'ens-menuiserie-ext',
    nom: 'Menuiseries Extérieures Alu',
    categorieId: 'enveloppe',
    sections: [
      { id: 'se-menext-chassis', nom: 'Châssis aluminium' },
      { id: 'se-menext-vitrage', nom: 'Vitrage isolant' },
      { id: 'se-menext-quincaillerie', nom: 'Quincaillerie oscillo-battant' },
    ],
  },

  // ── Technique et Installations ──
  {
    id: 'ens-distrib-elec',
    nom: 'Distribution Électrique',
    categorieId: 'technique',
    sections: [
      { id: 'se-elec-tgbt', nom: 'TGBT' },
      { id: 'se-elec-chemins', nom: 'Chemins de câbles' },
      { id: 'se-elec-appareillage', nom: 'Appareillage' },
    ],
  },
  {
    id: 'ens-courants-faibles',
    nom: 'Courants Faibles',
    categorieId: 'technique',
    sections: [
      { id: 'se-cf-rj45', nom: 'Réseau RJ45' },
      { id: 'se-cf-ssi', nom: 'SSI / Détection incendie' },
      { id: 'se-cf-controle', nom: 'Contrôle d\'accès' },
    ],
  },
  {
    id: 'ens-cvc-chaud',
    nom: 'CVC Chauffage',
    categorieId: 'technique',
    sections: [
      { id: 'se-cvc-chaudiere', nom: 'Chaudière / PAC' },
      { id: 'se-cvc-reseau', nom: 'Réseau de distribution' },
      { id: 'se-cvc-emetteurs', nom: 'Émetteurs' },
    ],
  },

  // ── Second Œuvre ──
  {
    id: 'ens-peinture-int',
    nom: 'Peinture Intérieure',
    categorieId: 'second-oeuvre',
    sections: [
      { id: 'se-peint-preparation', nom: 'Préparation supports' },
      { id: 'se-peint-impression', nom: 'Impression' },
      { id: 'se-peint-finition', nom: 'Finition 2 couches' },
    ],
  },
  {
    id: 'ens-peinture-ext',
    nom: 'Peinture Extérieure',
    categorieId: 'second-oeuvre',
    sections: [
      { id: 'se-peintext-decapage', nom: 'Décapage ancien' },
      { id: 'se-peintext-traitement', nom: 'Traitement anti-mousse' },
      { id: 'se-peintext-application', nom: 'Application peinture' },
    ],
  },
  {
    id: 'ens-cloisons',
    nom: 'Cloisons Plâtre',
    categorieId: 'second-oeuvre',
    sections: [
      { id: 'se-clois-ossature', nom: 'Ossature métallique' },
      { id: 'se-clois-isolant', nom: 'Isolant laine minérale' },
      { id: 'se-clois-plaques', nom: 'Plaques de plâtre' },
      { id: 'se-clois-joints', nom: 'Joints et finitions' },
    ],
  },

  // ── Extérieur et VRD ──
  {
    id: 'ens-vrd-reseaux',
    nom: 'VRD Réseaux',
    categorieId: 'exterieur',
    sections: [
      { id: 'se-vrd-tranchees', nom: 'Tranchées' },
      { id: 'se-vrd-canalisations', nom: 'Canalisations' },
      { id: 'se-vrd-regards', nom: 'Regards et boîtes' },
    ],
  },
];

// ── Helpers ──

/** Tous les lots, triés par ordre d'exécution */
export function getAvailableLots(): Lot[] {
  return getAllLots().sort((a, b) => a.ordre - b.ordre);
}

/** Ensembles filtrés par la catégorie du lot sélectionné */
export function getAvailableEnsembles(lotId?: string | null): ClassifyingEnsemble[] {
  if (!lotId) return CLASSIFYING_ENSEMBLES;

  const lot = getAllLots().find((l) => l.id === lotId);
  if (!lot) return [];

  return CLASSIFYING_ENSEMBLES.filter((e) => e.categorieId === lot.categorie);
}

/** Sous-ensembles (sections) de l'ensemble sélectionné */
export function getAvailableSousEnsembles(
  ensembleId?: string | null
): ClassifyingSousEnsemble[] {
  if (!ensembleId) return [];
  const ensemble = CLASSIFYING_ENSEMBLES.find((e) => e.id === ensembleId);
  return ensemble?.sections ?? [];
}

/** Catégorie d'un lot (pour affichage groupé) */
export function getLotCategoryLabel(lotId: string): string {
  for (const cat of CATEGORIES_LOTS) {
    if (cat.lots.some((l) => l.id === lotId)) return cat.nom;
  }
  return '';
}
